<style scoped="scoped" lang="scss"></style>

<template>
	<div style="display: inline;">
		<!-- table表格 -->
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/equipment/maintain/template/page"
			getKey="rows" :columns="columns">
			<!-- 搜索框插槽 -->
			<template #conditions>
				<el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
					<el-form-item :label="$t('shebeixiliemingcheng')">
						<el-input v-model="yt.conditions.equipmentSeriesName"></el-input>
					</el-form-item>
					<el-form-item :label="$t('shebeileixing')">
						<yi_dictionary_select :type="'EQUIPMENT_TYPES'" :ids.sync="yt.conditions.equipmentTypeId">
						</yi_dictionary_select>
					</el-form-item>
					<el-form-item>
						<el-button @click="yt.get(1)" type="primary"
							plain="plain">
							{{$t('sousuo')}}
						</el-button>
						<el-button @click="yt.clear()">{{$t('chongzhi')}}
						</el-button>
						<yi_curd_expand_button></yi_curd_expand_button>
					</el-form-item>
				</el-form>
			</template>
			<!-- 左侧按钮插槽 -->
			<template #buttonsL>
				<el-button size="mini" @click="yt.showEditDialog('xinzeng',null,'w1');setAddEnable()" type="primary"
					v-if="ids == null">
					{{$t('xinzeng')}}
				</el-button>
			</template>
			<!-- 右侧按钮插槽 -->
			<template #buttonsR>
				<!-- <el-button size="mini" icon="yicon yicon-export" :title="$t('daochu')"  @click="yt.exportExcel()"></el-button>
            </el-button> -->
				<el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')"  @click="yt.showColumnsDialog()"></el-button>
				</el-button>
			</template>
			<!-- 操作插槽 -->
			<template #caozuo="scope">
				<el-row :gutter="10">
					<el-col :span="0.1">
						<el-button type="text" @click="yt.showEditDialog('baoyangmingxi', scope.row,'70%')">
							{{$t('baoyangmingxi')}}
						</el-button>
					</el-col>
					<el-col :span="0.1">
						<el-button type="text" @click="yt.showEditDialog('bianji', scope.row)">{{$t('bianji')}}
						</el-button>
					</el-col>
					<el-col :span="0.1">
						<el-button type="text" class="font-color-danger"
							@click="yt.remove(scope.row,'/web/equipment/maintain/template/delete')">{{$t('shanchu')}}
						</el-button>
					</el-col>
				</el-row>
			</template>
			<template #shifouqiyong='scope'>
				{{scope.row.enable?$t('shi'):$t('fou')}}
			</template>
			<!-- 底部插槽 -->
			<!-- <div slot="footer"></div> -->
		</yi_curd_table>

		<!-- 新增/编辑弹框 -->
		<el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
			:width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
			<!-- 新增表单 -->
			<template v-if="yt.editObj.action == 'xinzeng'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item :label="$t('shebeixiliemingcheng')" required>
						<yi_cross_select :component="'admin_equipment_series_list'" :max="1"
							:ids.sync="yt.editObj.equipmentSeriesId"></yi_cross_select>
					</el-form-item>
					<el-form-item :label="$t('shifouqiyong')" required="required">
						<el-select v-model="yt.editObj.enable">
							<el-option :label="$t('shi')" :value="true"></el-option>
							<el-option :label="$t('fou')" :value="false"></el-option>
						</el-select>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button :loading="store.state.global_loading" size="mini"
						@click="yt.req('POST','/web/equipment/maintain/template/create')" type="primary">
						{{$t('baocun')}}
					</el-button>
				</span>
			</template>
			<!-- 更新表单 -->
			<template v-if="yt.editObj.action == 'bianji'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item :label="$t('shebeixiliemingcheng')" required>
						<el-input v-model="yt.editObj.equipmentSeriesName" disabled="true"></el-input>
					</el-form-item>
					<el-form-item :label="$t('shifouqiyong')" required="required">
						<el-select v-model="yt.editObj.enable">
							<el-option :label="$t('shi')" :value="true"></el-option>
							<el-option :label="$t('fou')" :value="false"></el-option>
						</el-select>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button :loading="store.state.global_loading" size="mini"
						@click="yt.req('POST','/web/equipment/maintain/template/update')" type="primary">
						{{$t('baocun')}}
					</el-button>
				</span>
			</template>
			<!-- 保养明细弹窗 -->
			<template v-if="yt.editObj.action == 'baoyangmingxi'">
				<div class="dialog-scroller">
					<maintenance_item :maintainTemplate="yt.editObj"></maintenance_item>
				</div>
			</template>
		</el-dialog>
	</div>
</template>
<script type="text/javascript">
	import maintenance_item from '@@/pages/admin/data_template/equipment/maintenance/maintenance_item'
	export default {
		components: {
			maintenance_item
		},
		name: 'admin_data_template_equipment_maintenance_list',


		data() {
			return {
				list: [],
				columns: [{
					label: 'shebeixiliemingcheng',
					prop: 'equipmentSeriesName',
					width: 130
				}, {
					label: 'shebeileixing',
					prop: 'equipmentTypeName',
					width: 130
				}, {
					label: 'shifouqiyong',
					type: 'slot',
					width: 80
				}, {
					label: 'chuangjianshijian',
					prop: 'createTime',
					type: 'time',
					format: 'YYYY-MM-DD HH:mm:ss',
				}, {
					label: 'caozuo',
					type: 'slot',
					width: 260,
					fixed: 'right'
				}]
			};
		},
		created() {
			setTimeout(() => {
				// table列表接口请求参数
				this.yt.conditions = {}
				this.yt.get(1);
			}, 300)

		},
		methods: {
			// 新增默认设置"是否启用"的值为启用
			setAddEnable() {
				this.yt.editObj.enable = true;
			}
		}
	};
</script>
